export default __webpack_public_path__ + "static/media/IMG_2242cropped.ed9e904e.jpeg";